<div class="totale container" [ngClass]="{'vedisx': toggle }">
     <div class="sinistra left">
        <mat-card class="ricerca">
            <mat-card-title>{{'Ricerca'|translate}}<a (click)="clickToggle()" class="aprisx"><i class="material-icons">&#xE5CD;</i></a></mat-card-title>
            <!--mat-card-subtitle>Utilizza i criteri per cercare l'accessorio voluto</mat-card-subtitle-->
            <form>
                <mat-input-container>
                    <input [(ngModel)]="codice" name="codice" matInput placeholder="{{'Cerca per codice'|translate}}">
                </mat-input-container><br>
                <mat-input-container>
                    <input [(ngModel)]="descrizione" name="descrizione" matInput placeholder="{{'Cerca per descrizione'|translate}}">
                </mat-input-container><br>
                <button mat-raised-button color="bottonebianco" (click)="cercaAccessori()">{{'Cerca'|translate}}</button>
            </form>
        </mat-card> 
        <br>
        <categoria-inline (onSelectCategoria)="onSelectCategoria($event)"></categoria-inline>
    </div>
    <div class="centro" style="min-height:500px;">
        <nav><a mat-raised-button color="bianco" (click)="clickToggle()" class="aprisx"><i class="material-icons">&#xE8B6;</i></a>
            <ul class="nav-wrapper"  *ngIf="!ricerca">
                <li><a mat-raised-button color="primary" (click)="reset()">{{'Accessori'|translate}}</a></li><li *ngFor="let m of navigazione"><span>&raquo;</span><a *ngIf="m.id!=categoriaCorrente.id" mat-raised-button color="primary" (click)="onSelectCategoria(m)">{{m.nome}}</a><a *ngIf="m.id==categoriaCorrente.id && !catAccessorioSelezionato" mat-raised-button color="accent" (click)="onSelectCategoria(m)">{{m.nome}}</a><a *ngIf="m.id==categoriaCorrente.id && catAccessorioSelezionato" mat-raised-button color="primary" (click)="onSelectCategoria(m)">{{m.nome}}</a></li><li *ngIf="catAccessorioSelezionato"><span>&raquo;</span><a (click)="vediAccessori(catAccessorioSelezionato)" mat-raised-button color="accent">{{catAccessorioSelezionato.nome}}</a></li><li style="float:right;" *ngIf="catAccessorioSelezionato"><a (click)="vediTuttiAccessori(catAccessorioSelezionato)" mat-raised-button color="bianco">{{'Vedi tutti '|translate}} '{{catAccessorioSelezionato.nome}}'</a></li>
            </ul>
            <ul class="nav-wrapper"  *ngIf="ricerca">
                <li><a mat-raised-button color="primary" (click)="reset()">{{'Accessori'|translate}}</a></li><li><span>&raquo;</span><a mat-raised-button color="accent">{{'Risultati ricerca'|translate}}</a></li>
            </ul>
        </nav>
        <div class="corpo">
            <div class="risultati" *ngIf="ricerca && !caricamento">
                <span *ngIf="accessoriTrovati.length<1">{{'Nessun risultato trovato'|translate}}</span>
            </div>
            <div *ngIf="caricamento">
                {{'In elaborazione...'|translate}}
            </div>
            <div [ngClass]="(!mostraMacchine)?'hidden':'categorie'">
                <categoria (onSelectCategoria)="onSelectCategoria($event)"></categoria>
            </div>

            <div *ngIf="mostraComp && comp.length>0" class="compatibilita">
                <h4 class='titologriglia'>{{'Tabella compatibilità accessori'|translate}}</h4>
                <table cellpadding="0" cellspacing="0">
                    <tbody>
                        <tr grid-item  *ngFor="let r of comp">
                            <td *ngFor="let x of r" [ngClass]="(x.tipo==1)?'macchina':(x.tipo==2)?'accessorio':(x.tipo==0 && x.testo=='Si')?'attivo':'vuoto'" align="center" valign="center">
                                <div class="cont" *ngIf="x.tipo!=0">
                                    <a *ngIf="x.tipo==1" [routerLink]="['/scheda', x.id]" title="{{x.testo}}">{{x.titolo}}</a>
                                    <a *ngIf="x.tipo==2" [routerLink]="['/accessorio', x.id]" title="{{x.testo}}">{{x.titolo}}</a>
                                </div>
                                <i *ngIf="(x.tipo==0 && x.testo=='Si')" class="material-icons" title="{{x.accessorio_txt}}">&#xE876;</i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div *ngIf="mostraLista  && accessoriTrovati.length>0" class="lista">

                <mat-card class="accessori-macchina">
                    <table class="mat-data-table" cellpadding="0" cellspacing="0" width="80%">
                        <thead>
                            <tr>

                                <th class="mdl-data-table__cell--non-numeric">
                                    <span>{{'Codice'|translate}}</span>
                                </th>
                                <th class="mdl-data-table__cell--non-numeric" width="60%">
                                    <span>{{'Descrizione'|translate}}</span>
                                </th>
                                <th *ngIf="utente && utente.prezzi" class=" mdl-data-table__cell--non-numeric">
                                    <span>{{'Prezzo €'|translate}}</span>
                                </th>
                                <th *ngIf="utente && utente.qta" class="number qta" width="50">
                                    <span>{{'Qta'|translate}}</span>
                                </th>
                                <th *ngIf="utente && utente.carrello" class=" mdl-data-table__cell--non-numeric">
                                    <span></span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr grid-item  *ngFor="let r of accessoriTrovati">
                                <td><a [routerLink]="['/accessorio', r.id]">{{r.codice}}</a></td>
                                <td>{{r.descrizione}}</td>
                                <td *ngIf="utente && utente.prezzi">{{r.prezzo}}</td>
                                <td *ngIf="utente && utente.qta" class="number qta"><input [(ngModel)]="r.qta" name="qta_{{r.id}}" type="number" min="1" step="1" size="2" /></td>
                                <td *ngIf="utente && utente.carrello"><a class="carrello" (click)="aggiungiCarrello(r)"><i class="material-icons">&#xE854;</i></a></td>
                            </tr>
                        </tbody>
                    </table>


                </mat-card>
            </div>

            <div *ngIf="mostraTipi && tipiTrovati && tipiTrovati.length>0" class="accessori">
                <!--h4>Scegli il tipo di accessorio</h4-->
                <div class="lista">
                    <div *ngFor="let m of tipiTrovati" class="card">
                        <mat-card >
                            <mat-card-header>
                                <mat-card-subtitle>{{ m.nome }}</mat-card-subtitle>
                            </mat-card-header>
                            <div class="img bgfix" [ngStyle]="{'background-image': 'url(' + m.img + ')'}">
                                 <!--img src="{{ m.img }}"-->
                        </div>
                        <mat-card-actions>
                            <button (click)="compatibilita(m)" mat-raised-button color="bottonebianco" class="btn-comp" >{{'Compatibilita'|translate}}</button> 
                            <button (click)="lista(m)" mat-raised-button color="bottonebianco" class="btn-list">{{'Vai alla lista'|translate}}</button>
                        </mat-card-actions>
                    </mat-card>
                </div>
            </div>
        </div><br>


    </div>
</div>
</div>


// WEBPACK FOOTER //
// ./src/app/tws-accessori/tws-accessori.component.html